module.exports = __webpack_public_path__ + "static/media/five.60376c54.png";